import to from "await-to-js";
import { t } from "i18next";
import { useContext, useMemo } from "react";

import { Modal } from "../../../../../../../components/Modal/Modal";
import { Select } from "../../../../../../../components/Select/Select";
import { ModalsContext } from "../../../../../../../context/modals.context";
import { MinistryContext } from "../../../../../../../modules/ministry/ministry.context";
import { ministryService } from "../../../../../../../modules/ministry/ministry.service";
import { exciseWarehouseService } from "../../../../../../../modules/obligee/exciseWarehouse/exciseWarehouse.service";
import { downloadFile } from "../../../../../../../utils/fileDownload";
import { toastService } from "../../../../../../../utils/toast.service";

export const DocumentTypeModal = () => {
  const { isModalVisible, clearModals, modals, setError } =
    useContext(ModalsContext);
  const { ministry, setMinistry, clearPayloadState } =
    useContext(MinistryContext);

  const type = modals.type;

  const handleCancel = () => {
    clearModals();
    clearPayloadState();
  };

  let queryParams = new URLSearchParams(window.location.search);
  const dozvolaZahtevId = Number(queryParams.get("id"));

  const createMfIzdavanjeResenja = async () => {
    const params = {
      isPoreskaPositive: ministry.isPoreskaPositive,
      dozvolaZahtevId: ministry.selectedLicenceId ?? dozvolaZahtevId,
      brojResenja: ministry.brojResenja,
      datumVazenja: ministry.datumVazenja,
      tipResenja: ministry.tipResenja,
      komentar: ministry.komentar,
      dokumentResenja: ministry.dokumentResenja,
    };

    const [err, res] = await to(
      ministryService.createMfIzdavanjeResenja(params)
    );
    if (err || !res.success) return setError(res?.errorMessage);
    toastService.success("TOAST.IZDAVANJE_RESENJA");
    setMinistry({ resenjeId: res.data });
    clearPayloadState();
    setTimeout(() => window.location.reload(), 500);
  };

  const fileName = useMemo(() => {
    if (ministry.detaljiODozvoli?.evidencioniBroj && ministry.tipResenja) {
      const tipResenjaNaziv =
        ministry.detaljiODozvoli?.akciznoSkladisteTipoviResenja?.find(
          (resenje) => resenje?.id === ministry?.tipResenja
        )?.name;

      return `${ministry.detaljiODozvoli?.evidencioniBroj}-${tipResenjaNaziv}-resenje`;
    }

    if (ministry.detaljiODozvoli?.evidencioniBroj) {
      return `${ministry.detaljiODozvoli?.evidencioniBroj}-resenje`;
    }

    return "resenje";
  }, [
    ministry.detaljiODozvoli?.evidencioniBroj,
    ministry.detaljiODozvoli?.akciznoSkladisteTipoviResenja,
    ministry.tipResenja,
  ]);

  const createGenerisanjeDozvolaDokumenta = async () => {
    const params = {
      resenjeId: ministry.resenjeId,
      dozvolaZahtevId: dozvolaZahtevId,
      tipResenja: ministry.tipResenja,
    };
    const [err, res] = await to(
      exciseWarehouseService.createGenerisanjeDozvolaDokumenta(params)
    );
    if (err || !res.success) return setError(res?.errorMessage);
    toastService.success("TOAST.DOWNLOAD_SUCCESS");

    downloadFile(res.data.content, fileName, "pdf");
  };

  const handleOk = () => {
    if (type === "resenje") {
      createGenerisanjeDozvolaDokumenta();
    } else {
      createMfIzdavanjeResenja();
    }
    clearModals();
  };

  const options = ministryService.getOptions(modals.data);

  const handleOkButton = () => {
    if (type === "resenje") return t("TABLES.GENERISI_RESENJE");
    return t("COMMON.POTVRDI");
  };

  return (
    <Modal
      name="tip-resenja-modal"
      title={t("COMMON.TIP_RESENJA_ZA_GENERISANJE")}
      onOk={handleOk}
      cancelText={t("COMMON.NAZAD")}
      cancelButtonProps={{ type: "default" }}
      okText={handleOkButton()}
      onCancel={handleCancel}
      open={isModalVisible("tipResenja")}
    >
      <div>
        <Select
          options={options}
          onChange={(value) => setMinistry({ tipResenja: value })}
          placeholder={t("PLACEHOLDERS.TIP_RESENJA")}
          value={ministry.tipResenja}
          className="w-50 ml-25"
          name="tip-resenja-select"
        />
      </div>
    </Modal>
  );
};
